import React, { useState } from "react";
import { VantagensContainer, StyledSlider, Slide } from "./Vantagens.js";

import Vantagem1off from "../../assets/cangoo-home-vatagens-01-off.png";
import Vantagem1on from "../../assets/cangoo-home-vatagens-01-on.png";
import Vantagem2off from "../../assets/cangoo-home-vatagens-02-off.png";
import Vantagem2on from "../../assets/cangoo-home-vatagens-02-on.png";
import Vantagem3off from "../../assets/cangoo-home-vatagens-03-off.png";
import Vantagem3on from "../../assets/cangoo-home-vatagens-03-on.png";
import Vantagem4off from "../../assets/cangoo-home-vatagens-04-off.png";
import Vantagem4on from "../../assets/cangoo-home-vatagens-04-on.png";
import Vantagem5off from "../../assets/cangoo-home-vatagens-05-off.png";
import Vantagem5on from "../../assets/cangoo-home-vatagens-05-on.png";
import Vantagem6off from "../../assets/cangoo-home-vatagens-06-off.png";
import Vantagem6on from "../../assets/cangoo-home-vatagens-06-on.png";
import Vantagem7off from "../../assets/cangoo-home-vatagens-07-off.png";
import Vantagem7on from "../../assets/cangoo-home-vatagens-07-on.png";
import Vantagem8off from "../../assets/cangoo-home-vatagens-08-off.png";
import Vantagem8on from "../../assets/cangoo-home-vatagens-08-on.png";
import Vantagem9off from "../../assets/cangoo-home-vatagens-09-off.png";
import Vantagem9on from "../../assets/cangoo-home-vatagens-09-on.png";

export function Vantagens() {
  const [hoverStates, setHoverStates] = useState(Array(9).fill(false));

  const toggleHoverState = (index, state) => {
    const newHoverStates = [...hoverStates];
    newHoverStates[index] = state;
    setHoverStates(newHoverStates);
  };

  const vantagens = [
    {
      title: "Cuidado do início ao fim",
      description: "Desde a coleta até a entrega, o cuidado com sua carga prevalece. Logo no aceite da mercadoria, verificamos se a embalagem está segura, e realizamos o acompanhamento da mercadoria em todo o trajeto.",
      off: Vantagem1off,
      on: Vantagem1on,
    },
    {
      title: "Atendimento Personalizado",
      description: "Possuímos diversos canais para atendimento, afinal de contas, prestar um bom atendimento, é parte crucial em nosso ramo.",
      off: Vantagem2off,
      on: Vantagem2on,
    },
    {
      title: "Agilidade",
      description: "Não estamos falando somente na coleta e entrega das suas mercadorias, mas na agilidade nos retornos, no suporte, e em tudo que envolve nossas operações.",
      off: Vantagem3off,
      on: Vantagem3on,
    },
    {
      title: "Logística Integrada",
      description: "A fim de poder atender a todas as demandas, além de dispormos do transporte aéreo, contamos com o transporte rodoviário também, assim, podemos atender todas as necessidades dos nossos clientes.",
      off: Vantagem4off,
      on: Vantagem4on,
    },
    {
      title: "Segurança",
      description: "Nosso índice de extravios, ou até mesmo de avarias nas cargas, é realmente muito pequeno! Uma vez que nossa demanda maior se dá através do setor aéreo, as chances são muito reduzidas. ",
      off: Vantagem5off,
      on: Vantagem5on,
    },
    {
      title: "Transparência",
      description: "Cansado em receber promessas de prazos que não são cumpridos? Fique tranquilo, aqui isso não existe! Jamais iremos correr o risco de prejudicar nossos clientes, por promessas que não podem ser cumpridas.",
      off: Vantagem6off,
      on: Vantagem6on,
    },
    {
      title: "Rastreio em tempo real",
      description: "Possuímos diversas formas de rastreio, sendo elas, via telefone, e-mail, WhatsApp, ou até mesmo, do nosso Portal do Cliente, lembrando que nosso sistema, dispara alertas a cada movimentação da mercadoria. ",
      off: Vantagem7off,
      on: Vantagem7on,
    },
    {
      title: "Abrangência Nacional",
      description: "Atendemos todo território nacional, tanto para coletar sua mercadoria, quanto para lhe entregar. Contamos com mais de 60 bases operacionais que realizam nossa operação.",
      off: Vantagem8off,
      on: Vantagem8on,
    },
    {
      title: "Suporte Eficiente",
      description: "Entendemos que nosso trabalho, é facilitar o seu, é entregar sua mercadoria no prazo, é lhe informar quando a entrega foi efetuada, é saber o quanto é importante fomentar o relacionamento entre cliente e fornecedor. ",
      off: Vantagem9off,
      on: Vantagem9on,
    },
  ];


  const responsiveSettings = [
    {
      breakpoint: 500, 
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 900, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    }
  ];


  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
  };

  return (
    <VantagensContainer disableGutters maxWidth={false}>
      <StyledSlider {...settings} responsive={responsiveSettings}>
        {vantagens.map((vantagem, index) => (
          <Slide key={index}>
            <img
              onMouseOver={() => toggleHoverState(index, true)}
              onMouseOut={() => toggleHoverState(index, false)}
              src={hoverStates[index] ? vantagem.on : vantagem.off}
              alt=""
            />
            <h1>{vantagem.title}</h1>
            <p>{vantagem.description}</p>
          </Slide>
        ))}
      </StyledSlider>
    </VantagensContainer>
  );
}